import { LastWatched } from '../../lastWatched';
import { Channel, ChannelAsset } from '../types';

import { tryCreateChannel } from './utils';

type ComposeOperatorsLineupArgs = {
  channelAssetsMap: Map<number, ChannelAsset>;
  channelCollection: Array<number>;
  entitledChannels: Set<number>;
  lastWatched: LastWatched | undefined;
};

export function composeOperatorsLineup({
  channelAssetsMap,
  channelCollection,
  entitledChannels,
  lastWatched,
}: ComposeOperatorsLineupArgs) {
  const channels: Array<Channel> = [];

  if (lastWatched) {
    const lastWatchedChannel = tryCreateChannel({ channelAssetsMap, entitledChannels, id: lastWatched.channelId });

    if (lastWatchedChannel) {
      channels.push(lastWatchedChannel);
    }
  }

  for (let i = 0; i < channelCollection.length; i++) {
    const channel = tryCreateChannel({ channelAssetsMap, entitledChannels, id: channelCollection[i] });

    if (!channel) {
      continue;
    }

    // if last watched channel exist on collection it must be first
    if (lastWatched?.channelId === channel.id) {
      continue;
    }

    channels.push(channel);
  }

  return channels;
}
